import fullUrl from '../../utils/fullUrl';

export default function canonicalLinkObj(canonicalPath) {
  return { rel: 'canonical', href: fullUrl(canonicalPath) };
}
